import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import MainDiag from './Main/MainDiag.jsx';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';

ReactDOM.render(<BrowserRouter><MainDiag /></BrowserRouter>, document.getElementById('root'));
serviceWorker.unregister();
